import React from 'react';
import { css } from 'emotion'
import Compu from '../images/MICROSITIO - COLACION 1.jpg'

const Header = () => {
    return (
        <header>

                <img src={Compu} alt="" className={css`
                    width: 100%;
                    height: 100%;
                `} />
                



        </header>
    );
};

export default Header;
